import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";
import { trapCounts } from "../videoBox/overlays/trapCards";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function PlayerCards({ name, count, cards, idx, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block w-100">
          <h4>
            {name} ({count})
          </h4>
          {idx.map((i) => (
            <React.Fragment key={i}>
              {" "}
              {cards[i] !== "1" && (
                <div className="casino-result-cards-item">
                  <img src={getCardImage(cards[i])} alt="" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for The Trap (trap): Player A = cards 0,2,…,12, Player B = 1,3,…,13
 * (backs "1" skipped) with their totals, trophy before the winner; rdesc "main#seven#picture".
 */
export default function TrapResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",").map((c) => c.trim()) : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const win = String(t1?.win ?? "");
  const { a, b } = trapCounts(cards);

  return (
    <div className="row row5">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <PlayerCards name="Player A" count={a} cards={cards} idx={[0, 2, 4, 6, 8, 10, 12]} isWinner={win === "1"} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <PlayerCards name="Player B" count={b} cards={cards} idx={[1, 3, 5, 7, 9, 11, 13]} isWinner={win === "2"} />
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Main</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Seven</div> <div>{desc[1]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Picture Card</div> <div>{desc[2]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
